import { Component, Input, OnChanges, OnInit } from '@angular/core'

@Component({
  selector: 'app-details-links',
  templateUrl: './details-links.component.html',
  standalone: false,
})
export class DetailsLinksComponent implements OnChanges {
  private lat: number | undefined = undefined
  private lon: number | undefined = undefined
  private zoom: number | undefined = undefined

  @Input() rawFeature: string | undefined = undefined
  @Input() zoomLevel: number | undefined = undefined

  ngOnChanges(): void {
    const feature = this.rawFeature ? JSON.parse(this.rawFeature) : undefined
    let coordinates: number[]

    if (feature) {
      if (feature.geometry.type === 'LineString') {
        // LineString: coordinates is [ [lon, lat], ... ]
        coordinates = feature.geometry.coordinates[0]
        this.lat = coordinates[1]
        this.lon = coordinates[0]
      } else if (feature.geometry.type === 'Point') {
        // Point: coordinates is [lon, lat]
        coordinates = feature.geometry.coordinates
        this.lat = coordinates[1]
        this.lon = coordinates[0]
      }
    }

    this.zoom = this.zoomLevel
  }

  public getGoogleMapsUrl() {
    return `https://www.google.com/maps/place/${this.lat}+${this.lon}/@${this.lat},${this.lon},${this.zoom}z/data=!3m1!1e3!?entry=ttu`
  }

  public getBingMapsUrl() {
    return `https://www.bing.com/maps?v=2&cp=${this.lat}%7E${this.lon}&sp=Polyline.${this.lat}_${
      this.lon
    }_${this.lat! + 0.0000001}_${this.lon! + 0.0000001}_LINE____%2300ff00__14px_Single_Solid&lvl=${
      this.zoom
    }&style=h`
  }

  public getOsmUrl() {
    return `https://www.openstreetmap.org/#map=${this.zoom}/${this.lat}/${this.lon}`
  }

  public getStreetViewUrl() {
    return `http://maps.google.com/maps?q=&layer=c&cbll=${this.lat},${this.lon}&cbp=11,0,0,0,0`
  }

  public getAppleViewUrl() {
    return `https://maps.apple.com/?ll=${this.lat},${this.lon}&q=&spn=0.000634,0.001007&t=m`
  }

  public getMapillaryUrl() {
    return `https://www.mapillary.com/app/?lat=${this.lat}&lng=${this.lon}&z=${this.zoom}&focus=map&dateFrom=2026-01-01&trafficSign=all`
  }
}
